<template>
  <div class="pwc-app-login">
    <van-image class="pwc-login-logo" width="230" :src="logo" />
    <van-cell-group :border="false">
      <van-field :value="cCountryInfo" class="pwc-login-item" label="国家" right-icon="arrow" :placeholder="cCountryInfo" @click="handleSelectCountryCode" />
      <van-field v-model="cPhone" class="pwc-login-item" type="number" clearable label="手机号" placeholder="请输入手机号" maxlength="14" />
      <van-field v-model="verifyCode" class="pwc-login-item" type="number" label="验证码" placeholder="请输入6位验证码" maxlength="6">
        <van-button slot="button" :disabled="cVerifyDisabled" class="pwc-login-verify" size="small" plain hairline type="primary" @click="handleVerify">{{ cVerifyButtonText }}</van-button>
      </van-field>
      <van-button class="pwc-login-action" type="info" size="large" :disabled="loginDisable" @click="handleLogin">确定</van-button>
      <van-collapse v-model="activeNames" :border="isborder" style="padding-top:12px;">
        <van-collapse-item name="1">
          <div slot="title">
            <van-checkbox v-model="privacyAgreed" class="pwc-privacy" shape="square" checked-color="#d04a02">
              <span>我了解并接受
                <a href="#">&nbsp;隐私条款&nbsp;</a>和
                <a href="#">&nbsp;使用条款</a>
              </span>
            </van-checkbox>
          </div>
          <div>
            <p><b>隐私条款</b></p>
            <p>
              我们非常重视您在本网站所提供信息的隐私权。您通过本网站向普华永道商务技能培训(上海)（以下简称“普华永道”或“我们”）提交的个人信息，其收集和使用将适用于以下的隐私权声明。普华永道将按照公认的隐私及数据保护的良好做法处理相关信息。
            </p>
            <p>
              本网站的部分功能可在未注册用户前提下使用，然而某些部分涉及You Plus特训计划(“本项目”) 的内容（如在线申请或项目参与事宜）需要您提供相关个人信息并注册用户名及密码后方可使用。妥善保存用户名及密码不泄露、以及提供真实准确的信息是您的个人的责任。
            </p>
            <p>
              使用者透过本网站注册及提交个人信息，意味着您确认同意普华永道按照本隐私权声明来使用该信息。本隐私权声明是我们对您个人信息保护的承诺。如果您不同意本声明，或您选择不向我们提供相关个人信息，我们可能无法向您提供本网站上项目相关事宜。
            </p>
            <p>
              “个人信息”是指有关您以及/或者您所代表的第三方的信息(如您的用人单位，如适用)。当您使用本网站，我们可能会以某种方式收集一些个人信息，其中包括：直接要求您提供数据，或我们在您的授权下从第三方，例如您的用人单位，获取信息；或者以间接方式收集信息，如利用Cookies技术（见以下所述）、通过为您定制个性化网页或追踪您对网站某些页面的使用情况（如IP地址）及使用其他技术方法监控您对网站的使用情况，或由第三方向我们提供关于您的信息等方式。
            </p>
            <p>
              我们将只按照本隐私权声明所述来收集、存储、处理、使用、沟通、传递和/或披露个人信息。如果您是中间人或代表第三方行事，或者向我们提供第三方的信息，您承诺您是经该第三方授权的代表或代理人，而且您取得了该第三方对我们收集、存储、处理、使用、沟通、传递和/或披露其个人信息所有必要的同意。鉴于我们是通过您获取第三方的个人信息，您保证第三方知悉本隐私权声明中的所有内容，最好你能将本隐私声明的文本提供给他们或介绍他们浏览我们的网站。如您未经授权而使用第三方个人信息，您应赔偿我们并保证使我们免受因此而产生的损失和损害。
            </p>
            <p>
              您将对在本网站上提交的个人信息准确性负责。不准确的信息可能将阻碍您使用本网站，收取网站相关信息，及我们与您取得联系。
            </p>
            <p>
              本隐私权声明仅适用于我们通过本网站收集的个人信息，并不适用于我们通过其他渠道（如邮件、手机）所收集的信息。
            </p>
            <p>
              通常情况下，普华永道仅收集如联系方式方面的信息，但在必要时，访问者可自愿并特别地提供其他个人信息。所收集的个人信息一般用于您：
            </p>
            <p>
              <ul>
                <li>
                  查询信息
                </li>
                <li>
                  在网站上进行注册 (如用户名和密码)以便访问本网站的某些功能
                </li>
                <li>
                  提交在线申请（例如提供的数据包括但不限于姓名，身份证件号码，电子邮箱，邮寄地址，联系电话，教育背景，工作经验，简历等等）
                </li>
                <li>
                  身份验证以便允许您进入某些相关页面（如学生，教职人员，及/或注册企业等专属页面,如果适用）
                </li>
                <li>
                  促进本项目的各个过程（如管理申请信息及档案资料，检视申请状态，申请奖学金或助学金）
                </li>
                <li>
                  允许您提交本项目的信息和文档
                </li>
                <li>
                  评估您是否适合本项目和您的持续绩效（包括提供给第三方执行特定相关服务的数据）
                </li>
                <li>
                  辅助您作为学生（例如课程选择和更新）、教师或注册企业（即注册将为学生提供实践培训经验和/或机会的企业）参与项目
                </li>
                <li>
                  向您发送有关本项目的相关通知及信息（如课程资料，日程安排，项目进展，评估结果等）。我们也可以告知您其他我们的类似服务和产品。）
                </li>
                <li>
                  提供学生资料(包括个人信息)，以便注册实体选择学生作为实践培训经验和/或其他机会的候选人
                </li>
                <li>
                  参与调查或活动反馈
                </li>
                <li>&nbsp;</li>
              </ul>
            </p>
            <p>
              此外，我们也可能为操作、管理本网站或分析本网站的运行而使用您的个人信息。
            </p>
            <p>
              如果您出于某种原因自愿提供敏感信息, 例如以下几类信息：种族或民族、政治观点、宗教信仰、是否为工会会员、健康状况、性倾向或犯罪记录等，您提供该等敏感信息的行为意味着您也明确同意按照本隐私权声明或按照您披露信息时所述的方式来使用这些信息。
            </p>
            <p>
              我们网站会部分地使用Cookies技术。Cookies是一种小型应用软件，能使网站识别出以往用户并且了解用户访问网站的习惯。目前使用Cookies已经成为一种标准，被许多网站用以改善用户的网站访问体验。如果您对cookies有所顾虑，现在大多浏览器允许用户拒绝使用Cookies。大多数情况下，访问者可以拒绝使用Cookies而仍然能够完全浏览我们的网站，但网站上的某些功能可能会受到影响。在结束浏览我们的网站后，访问者可以从系统中删除Cookies。
            </p>
            <p>
              为了恰当管理网站及相关邮件服务，我们会在网站操作系统上以不记名方式记录网站的访问量及访问时长等信息及按域名及浏览器类型等方面对访问者予以分类并通过邮件的确认或回执来追踪文件的识别号码。这些统计数据将汇总报至网络管理员和系统管理员。另外，网站上的统计数字由第三方进行编撰，因此仅为了统计的目的，您的IP地址将被提供给该第三方。这种做法是为了确保向访问者提供有效的信息资源并使访问者在我们的网站上获得最佳的浏览体验。
            </p>
            <p>
              注册用户访问本网站时，需要登录确认身份以获得访问权限。普华永道记录身份数据主要是为了就您在本网站上要求我们提供的信息与您联络、检测网站服务的好坏并协助解决网络技术问题。
            </p>
            <p>
              本网站中注册的信息将仅被用于本隐私权声明中“信息收集”条款中所提及的目的。
            </p>
            <p>
              普华永道不会将本网站收集的个人信息用于未经同意的营销活动用户批准的市场行为。
            </p>
            <p>
              普华永道系指普华永道网络及/或普华永道网络中各自独立的成员机构。详情请进入www.pwc.com/structure。向您收集个人信息的组织可能是为您提供服务的普华永道成员机构或负责该网站运作的成员机构。
            </p>
            <p>
              普华永道可以为本隐私权声明中描述的目的而向其他普华永道实体及注册企业提供或披露您的信息。普华永道及其他普华永道实体可能使用遍布在不同国家和地区的资源和服务器来处理您的个人信息。因而，您的个人信息有可能被传递至其他国家和地区。
            </p>
            <p>
              普华永道及其他普华永道实体与为我们提供服务的第三方一起工作。我们可能向该第三方服务提供商提供或披露您的信息，包括那些代表我们处理数据的机构或者为普华永道的商业运营提供其他服务，如信息技术，网站维护，数据分析，数据备份，数据安全和存储服务的供应商。我们所使用的第三方可能也会使用他们自己的第三方（分包商）。不论我们还是该等第三方都有责任维持适当的安全和保密水平，并且仅将信息适用于指定用途。
            </p>
            <p>

              如果适用于法律法规要求，我们可能将向执法部门，管理当局，其他政府机构或其他第三方披露您的个人信息。
            </p>
            <p>
              通过本网站提交您的个人信息的行为即表明为实现其自愿请求的目的，您明确同意普华永道可以向其他普华永道实体或第三方为本隐私权声明中明确规定的目的提供或披露您的数据。我们也可能为了您提供信息给我们的目的，将您的个人信息从您所在的国家或地区进行跨境传送，转移到可能无法为您的个人信息提供同等法律保护的国家或地区。
            </p>
            <p>

              信息过时或已不再需要，经过合理的期限后，将会被销毁或予以永久的匿名处理。但为了内部存档以及遵守法律或专业标准的需要，我们可能会长期保留信息。
            </p>
            <p>

              您有权访问注册在网站的个人信息。 您可以给You Plus项目管理组 发送邮件至 PwCEducationEnquiry@cn.pwc.com来访问您注册的信息。
            </p>
            <p>
              在个人信息需要予以保留时，访问者一旦提交信息，普华永道将负责对信息的记录保存。普华永道不承担核实个人信息内容准确性的责任。在实际可行的情况下，如普华永道被告知通过网络所收集的个人信息不再准确，普华永道将在经确认身份的访问者提供的最新信息的基础上作出恰当的更改。
            </p>
            <p>
              如需更新您的联系方式（例如，电子邮件、工作单位、职位/职务、地址、电话号码）请给You Plus项目管理组发送邮件至PwCEducationEnquiry@cn.pwc.com。如果您认为我们持有您相关的信息是不准确的，或者您对我们处理您个人信息的方式有疑虑，或者您对我们如何使用您的信息改变了想法，请通知我们，我们会尽力解决您的疑虑。
            </p>
            <p>
              您提交的信息会存储在电子邮箱或数据库中。普华永道使用公认的技术和安全操作标准以保护个人信息免遭未经授权的查阅、处理、清楚、丢失、误用、篡改或损坏。所有普华永道员工均遵守公司的有关信息安全方面的规定。仅有经授权的普华永道员工才可以访问个人信息并且他们已经承诺对信息予以保密。该政策同样适用于我们公司相关的代理人。
            </p>
            <p>
              有下述情形之一的，个人信息可能会被披露给普华永道国际网络中的其他成员机构：
            </p>
            <p>
              (1) 为满足访问者提交信息所要达到的目的
            </p>
            <p>
              (2) 基于访问者自愿请求的性质及目的，在未来为访问者提供相关的或其感兴趣的信息
            </p>
            <p>
              通过本网站提交您的个人信息的行为即表明您明确同意普华永道可以跨境传送此类数据，以实现您的自愿请求。
            </p>
            <p>
              普华永道希望为您尽可能提供信息全面、资源丰富的网站体验，因此我们可能提供一些第三方网站的链接。普华永道对访问者通过我们而访问的第三方网站的信息不承担任何法律责任。当您链接到这些网站时，普华永道的隐私权保护不再适用。我们建议，在透露任何个人信息前，访问者应查阅每一网站的隐私权保护政策。
            </p>
            <p>
              普华永道有权随时以任何理由更正或修改本隐私权声明。我们将在修订生效前在网站上进行公示。隐私权声明变更生效后，若您继续使用我们的网站，即表示同意受经修订的本隐私权声明的约束。
            </p>
            <p>
              我们热切盼望能听到您关于本隐私权声明以及本网站宝贵的意见和建议。如您有任何相关意见或建议，请通过邮箱PwCEducationEnquiry@cn.pwc.com发送邮件联系You Plus项目管理组。
            </p>
            <br>
            <br>
            <p>
              <b>使用条款</b>
            </p>
            <p>
              IMPORTANT—PLEASE READ CAREFULLY:
            </p>
            <p>
              THE FOLLOWING TERMS AND CONDITIONS SET FORTH THE RIGHTS AND OBLIGATIONS OF YOU WHEN USING THE WEB SITE. PLEASE READ CAREFULLY BEFORE USE THE WEB SITE AND COMPLY WITH THIS ONLINE TERMS AND CONDITIONS OF USE [AS WELL AS THE PRIVACY STATEMENT] UPON YOUR CONFIRMATION OF AGREEMENT.
            </p>
            <p>
              This is a legally binding contract (the “Agreement”) between you and PricewaterhouseCoopers Business Training (Shanghai) Co., Ltd (“PwC” or “We”) governing your use of the "You Plus official website" (the “Web Site”).
            </p>
            <p>
              Your use of the Web Site is subject to the following terms and conditions:
            </p>
            <p>
              1. Use of the Web Site.
            </p>
            <p>
              1.1 Use of the Web Site.
            </p>
            <p>
              This Agreement only governs your use of the Web Site – it does NOT govern any services. Any terms and conditions related to HNTE and/or Super deduction services are the subject of various professional standards and regulations as well as a separate agreement between PwC or other PwC Firms (refer to any entity or partnership within the worldwide network of PricewaterhouseCoopers firms and entities, “PwC Firms”) and you. Notwithstanding any provisions or indications to the contrary, the contractual relationship under this Agreement remains between you and PwC. Another PwC firm who deals with you in connection with the Agreement does so solely on our behalf.
            </p>
            <p>
              BY TICKING THE ACKNOWLEDGEMENT BOX “I HAVE READ CAREFULLY AND AGREE TO THE ONLINE TERMS AND CONDITIONS OF USE AND PRIVACY STATEMENT” AT FIRST LOGIN, YOU REPRESENT THAT YOU IRREVOCABLY ACCEPT ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT WITHOUT MODIFICATION OR VARIATION. IF YOU DO NOT AGREE TO BE BOUND BY THIS AGREEMENT IN ITS ENTIRETY, PLEASE DO NOT PROCEED ANY FURTHER AND EXIT THE WEB SITE.
            </p>
            <p>
              PwC reserves the right to reject any registration request at its sole discretion.
            </p>
            <p>
              1.2 Notes of Use.
            </p>
            <p>
              In relation to your use of the Web Site, you must:
            </p>
            <p>
              familiarise yourself with, and comply with, all terms and conditions applicable to use of the Web Site;
              protect your login credentials and contact PwC immediately if you believe that those details have been compromised; and
              respond to any queries in relation to the Web Site raised by PwC in a timely manner
            </p>
            <p>
              2. Online Information Exchange
            </p>
            <p>
              2.1 Online Information Exchange.
            </p>
            <p>
              Unless expressly stated otherwise, the Web Site is provided for general guidance and information exchange purposes only. No charging service will actually be performed through the Web Site, which only enables the information exchange between you and PwC.
            </p>
            <p>
              The Web Site allows you to input your personal data in order to apply for and join in PwC You Plus Program. You understand and agree that for the purpose of selecting students and facilitating the You Plus Program, PwC may give the information provided by you to other PwC Firms or relevant subcontractors. For details please refer to the Privacy Statement. You further understand and agree that, without prejudice to any provisions of the Privacy Statement, for the following purposes, the information you provided on the Web Site will be made available to relevant third parties:
            </p>
            <p>
              to faculties, administrative and management staff or other relevant persons who may not be employees of PwC, in order to determine which ones among those applied for the program are to be admitted;
            </p>
            <p>
              to enterprises that are intended to provide practical training opportunities to students as part of the You Plus Program, for them to determine if any students are suitable for and to be accepted in their own practical training program;
            </p>
            <p>
              during or after the completion of the You Plus Program, to enterprises interested in hiring students as their employees, for them to review and contact students.
            </p>
            <p>
              We will not be responsible for or make any warrant with respect to such third party’s further use and disclosure of your information.
            </p>
            <p>
              You shall ensure the authentication, accuracy and completeness of the information you provided and shall timely update the same when there is any change. You also warrant that you are entitled to provide such information. Once you are admitted by PwC You Plus Program, PwC will enter into a training agreement with you. PwC at its discretion may refuse to process your request.
            </p>
            <p>
              The Web Site should not be used as a substitute for consultation with professional tax, accounting, legal or other suitably qualified advisors. Before making any decision or taking any action, you should consult with PwC or an applicable professional advisor who has been provided with all pertinent facts relevant to your particular situation. Given the changing nature of laws, rules and regulations and the inherent hazards of electronic communication there may be delays, omissions or inaccuracies in the information presented on this Web Site.
            </p>
            <p>
              2.2 Security.
            </p>
            <p>
              You shall register an account and create your username and password in accordance with the instruction of the Web Site or PwC at first login. You will be required to enter your username and password every time you wish to access the Web Site. Your username and password are personal to you and non-transferable, and you shall maintain them in strict confidence and will not communicate them to anyone else or allow anyone else to use them. YOU ARE RESPONSIBLE FOR ALL USE OF THE WEB SITE MADE USING YOUR USERNAME AND PASSWORD, REGARDLESS OF THE IDENTITY OF THE PERSON MAKING SUCH USE, AND PWC, OTHER PWC FIRMS AND ITS AFFILIATES, LICENSORS AND SUPPLIERS WILL NOT HAVE ANY RESPONSIBILITY OR LIABILITY IN CONNECTION WITH ANY UNAUTHORIZED USE OF THE USERNAMES OR PASSWORDS OR ANY UNAUTHORIZED USE OF OR WITHIN THE WEB SITE. If you become aware of or suspect a breach of security with respect to your password or of any other breach of security, you will immediately notify PwC. Your access to or use of the Web Site may be immediately suspended with or without notice by PwC at any time for any reason.
            </p>
            <p>
              2.3 Restrictions.
            </p>
            <p>
              Except as otherwise expressly permitted under this Agreement, you may not do any of the following, nor may you authorize any third party to do any of the following with respect to the Web Site, including without limitation any of its related technology and databases:
            </p>
            <p>
              (a) Access or use any portion of the Web Site except for the purposes expressly stated in this Agreement;
            </p>
            <p>
              (b) Reproduce or copy any portion of the Web Site;
            </p>
            <p>
              (c) Modify the Web Site or create any derivative works from the Web Site, or otherwise change the Web Site or the underlying data, systems or software;
            </p>
            <p>
              (d) Decompile, disassemble, reverse engineer, or otherwise attempt to derive the related source code of the Web Site;
            </p>
            <p>
              (e) Redistribute, encumber, sell, rent, lease, use for service bureau purposes, sublicense or otherwise transfer any related rights; or
            </p>
            <p>
              (f) Remove or alter any related trademark, logo, copyright or other proprietary notices, legends, symbols or labels.
            </p>
            <p>
              2.4 Posting of Information and Access Thereto; Suspension of Service.
            </p>
            <p>
              You will not use the Web Site to post or transmit any information or content in violation of any applicable law or regulation, or in any manner that violates, infringes or misappropriates any third party right or interest, or in any manner that may cause harm or damage of any kind. Among other prohibited activities and without limiting the foregoing, you must not make available or promote in or through the Web Site any material which: (a) infringes any person’s intellectual property, confidentiality, privacy or other rights or breaches any restrictions on the use of any material, regardless of whether the relevant restrictions or rights are imposed or granted by law or by agreement with PwC or anyone else; (b) is or is likely to be perceived as defamatory, threatening, misleading, offensive or inappropriate, or materially misrepresents facts; (c) adversely affects performance or availability of the Web Site, or places an undue load on PwC network resources; (d) contains any virus, harmful component or corrupted data or otherwise threatens the security of the Web Site or PwC systems; (e) contains any advertising, promotion or solicitation.
            </p>
            <p>
              You further agree you will not, under any circumstances: (a) upload, transfer or provide PwC with any information which contains China state secrets; (b) download or access any information from PwC’s systems outside of China; or (c) provide PwC with personal data unless necessary for the using the Web Site and in compliance with any applicable data protection laws and regulations.
            </p>
            <p>
              You understand that PwC cannot and will not undertake to approve or endorse any material uploaded, posted or published by you or by other users of the Web Site. Notwithstanding that PwC is under no obligation to read, approve or endorse material uploaded, posted or published in connection with the Web Site, PwC may monitor your use of the Web Site from time to time but does not commit to doing so. Where PwC monitors, it will do so in accordance with applicable law. In the event that PwC becomes aware of, or a third party notifies PwC that the third party believes that information or content posted or placed on the Web Site violates an applicable law or regulation, or violates, infringes, misappropriates any third party right or interest, or otherwise unlawfully harms or damages an individual or entity, PwC may suspend service on part or all of the Web Site to which the allegations pertain and may delete relevant information or materials at its sole discretion. PwC further reserves the right to deny you access to the Web Site and make claims against you in accordance with laws and this Agreement in the event PwC believes that you may have violated the provisions of this Section or are otherwise in breach of this Agreement. In addition, PwC may, without notice, suspend all services to you hereunder, destroy any information or data entered by you on the Web Site, and/or block your access to the Web Site to the extent that PwC is required by law or order of any court or regulatory agency to do so.
            </p>
            <p>
              2.5 Linking.
            </p>
            <p>
              You may not link to the Web Site from any website without PwC’s prior written consent. If and where the Web Site provides links to any third party website, such website, regardless whether created by PwC, may not be under PwC’s control and accordingly PwC will have no responsibility for, and does not make any representations or warranties with respect to, such website or any content, products or services in connection therewith, and PwC does not endorse any of the same.
            </p>
            <p>
              2.6 Compliance with Laws.
            </p>
            <p>
              You will comply with all applicable domestic and foreign laws, rules and regulations in connection with your use of the Web Site provided hereunder.
            </p>
            <p>
              2.7 Changes to Web Site.
            </p>
            <p>
              PwC may amend this Agreement at any time and reserves the right to change without notice, at its sole discretion, the content, presentation, performance, functionality and availability of the Web Site.WHERE PWC AMENDS THIS AGREEMENT, YOU WILL BE INFORMED OF THE AMENDED TERMS THE FIRST TIME YOU LOGIN AFTER THE AMENDMENT. BY TICKING “I AGREE” AFTER CAREFULLY READ THE AMENDED AGREEMENT, YOU REPRESENT THAT YOU IRREVOCABLY ACCEPT THE AMENDMENT TO THIS AGREEMENT WITHOUT MODIFICATION OR VARIATION. IF YOU DO NOT WISH TO ACCEPT SUCH AMENDMENT, YOU ARE DEEMED TO HAVE TERMINATED THIS AGREEMENT AND PWC WILL CEASE TO PROVIDE THE WEB SITE TO YOU. This Agreement may not be otherwise amended.
            </p>
            <p>
              2.8 Ownership.
            </p>
            <p>
              All right, title and interest in and to the Web Site, including without limitation all that attached to information and related technology, shall remain with PwC and/or its licensors (except with respect to content placed on the Web Site by you and certain other third parties), and you shall have no rights in the Web Site or any of PwC’s other intellectual property. You acknowledge such ownership and intellectual property rights and will not take any action to jeopardize, limit or interfere in any manner with PwC’s or its licensors’ ownership of or rights with respect to the same.
            </p>
            <p>
              3. Indemnification
            </p>
            <p>
              To the maximum extent permitted by applicable law, you agree to defend (at the indemnified party’s option), indemnify and hold PwC and its respective partners, directors, employees, licensors, agents, affiliates, other PwC Firms, business associates, suppliers and insurers harmless from and against any and all losses, damages, liabilities, costs (including reasonable attorneys’ fees) and expenses in connection with any claim arising out of or in connection with any content or information posted or transmitted by you using the Web Site or that otherwise arise out of your use of the Web Site or that of any other third party who is given or gains access to the Web Site due to your action or inaction. At any time, PwC has the right to forego the indemnification and assume the defence of any claim. Notwithstanding the foregoing, it is not the intent of the parties to affect the rights of PwC’s insurers to assume the defence or settlement of any claim against PwC for which insurance coverage is sought under any PwC policy.
            </p>
            <p>
              4. Disclaimers and Assumptions of Risk
            </p>
            <p>
              4.1 General Disclaimer.
            </p>
            <p>
              THE WEB SITE AND INFORMATION PROVIDED TO YOU HEREUNDER ARE PROVIDED “AS IS,” “AS AVAILABLE,” AND TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, PWC, OTHER PWC FIRMS AND ITS LICENSORS, BUSINESS ASSOCIATES AND SUPPLIERS DISCLAIM ALL WARRANTIES WITH RESPECT TO THE SAME, EXPRESS, IMPLIED AND STATUTORY, INCLUDING WITHOUT LIMITATION ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, ACCURACY, COMPLETENESS, NON-INFRINGEMENT, NON-INTERFERENCE, ERROR-FREE SERVICE AND UNINTERRUPTED SERVICE. THIS AGREEMENT IS NOT AN OFFER OF ANY GOODS OR SERVICES EXCEPT FOR THOSE EXPLICITLY PROVIDED HEREUNDER. PWC TAKES NO RESPONSIBILITY FOR MONITORING OR REGULATING THE RELATIONSHIP BY AND AMONG YOU AND ANY OTHER PERSONS WHO USE THE WEB SITE PROVIDED HEREUNDER.
            </p>
            <p>
              4.2 Downtime, Data Loss and Security.
            </p>
            <p>
              You understand and agree that no representation or warranty is made with respect to the functionality or availability of the Web Site, and that all or any portion(s) of the Web Site may for a variety of reasons be unavailable to you for use either temporarily or permanently without notice. You further agree and understand that information and data related to the Web Site may be irretrievably lost or destroyed at any time, and it will be your responsibility to make all necessary copies and backups of any appropriate information and data posted to or obtained or available from the Web Site. YOU AGREE THAT PWC, OTHER PWC FIRMS, ITS AFFILIATES, LICENSORS AND SUPPLIERS WILL NOT HAVE ANY LIABILITY DUE TO YOUR INABILITY TO ACCESS THE WEB SITE, ANY PORTION THEREOF OR ANY RELATED DATA OR INFORMATION, AND WILL NOT HAVE ANY LIABILITY IN CONNECTION WITH THE LOSS OR DESTRUCTION OF ANY SUCH DATA OR INFORMATION. You understand and acknowledge that no web site or network is immune from unauthorized access. Accordingly, PwC will not have any liability or responsibility in connection with any unauthorized access to the Web Site. You understand and agree that the Web Site may be unavailable due to scheduled maintenance. PwC reserves the right to prevent or limit access to the Web Site for security, upgrades or other reasonable purposes.
            </p>
            <p>
              5. Limitation of Liability
            </p>
            <p>
              TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, NEITHER PWC NOR ITS OFFICERS, DIRECTORS, PARTNERS, EMPLOYEES, AGENTS, AFFILIATES, OTHER PWC FIRMS, BUSINESS ASSOCIATES, LICENSORS OR SUPPLIERS WILL BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES, INCLUDING WITHOUT LIMITATION DAMAGES FOR LOST PROFITS OR REVENUES, GOODWILL, WORK STOPPAGE, SECURITY BREACHES, VIRUSES, COMPUTER FAILURE OR MALFUNCTION, DATA OR OTHER INTANGIBLE LOSSES OR COMMERCIAL DAMAGES, EVEN IF ANY OF SUCH PARTIES ARE ADVISED OF THE POSSIBILITY OF SUCH LOSSES, ARISING UNDER OR IN CONNECTION WITH THIS AGREEMENT, THE WEB SITE, THE USE OF OR INABILITY TO USE THE SAME, OR ANY OTHER SUBJECT MATTER HEREOF. IN ADDITION, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, NEITHER PWC NOR ITS AFFILIATES, LICENSORS OR SUPPLIERS WILL BE LIABLE FOR ANY LOSS OR DAMAGE SUFFERED BY YOU WHICH ARISES OUT OF OR IN CONNECTION WITH ANY INFORMATION OBTAINED BY YOU VIA OR IN CONNECTION WITH THE WEB SITE. TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, PWC, ITS OFFICERS, DIRECTORS, PARTNERS, EMPLOYEES, AGENTS, AFFILIATES, OTHER PWC FIRMS, LICENSORS, BUSINESS ASSOCIATES AND SUPPLIERS WILL NOT BE LIABLE FOR ANY DAMANGES OR LOSSES ARISING FROM OR IN CONNECTION WITH ANY INFORMATION YOU ACQUIRED FROM THIS WEB SITE OR OTHER RELATED CHANNEL.
            </p>
            <p>
              6. Term and Termination
            </p>
            <p>
              PwC may, without terminating this Agreement, suspend the provision of the Web Site in whole or in part until further notice without warning for any reason. Either party may terminate this Agreement, with or without cause, at any time. All terms and condition of this Agreement that are intended by their nature to survive termination of this Agreement shall survive termination and remain in full force, including but not limited to the terms and conditions concerning any disclaimers, intellectual property rights, duties of confidentiality, limitations of liability, duties of indemnification, and provisions regarding resolution of differences. Although each party's further rights and obligations cease immediately on termination of this Agreement, termination does not affect a party's accrued rights and obligations at the date of termination.
            </p>
            <p>
              7. General
            </p>
            <p>
              7.1 Governing Law, Jurisdiction and Venue.
            </p>
            <p>
              This Agreement will be governed by and construed in accordance with applicable laws of the People’s Republic of China, exclude the rule of conflict of laws. Each party irrevocably consents to submit the dispute arising from this agreement to China International Economic and Trade Arbitration Commission in Beijing for arbitration which shall be conducted in accordance with the commission’s arbitration rules then effective. The arbitral tribunal shall consist of three arbitrators who shall be appointed in accordance with the commission’s rules. The arbitral award shall be final and binding upon both parties.
            </p>
            <p>
              7.2 Conflict; Severability.
            </p>
            <p>
              In the event of any conflict between this Agreement and any procedures or requirements set out in the Web Site, the provisions of this Agreement will prevail. If any provision of this Agreement is held to be invalid, void or illegal, it will be severed from this Agreement and will not affect, impair or invalidate any other provision, and it will be replaced by a provision which comes closest to such severed provision in language and intent without being invalid, void or illegal.
            </p>
            <p>
              You may not assign, transfer, change or otherwise seek to deal with any rights or obligations under this Agreement without the prior written consent of PwC. PwC may without consent assign this Agreement.
            </p>
            <p>
              7.4 No Implied Waiver.
            </p>
            <p>
              No right under this Agreement may be waived except in writing signed by the parties hereto. The failure of either party to require performance of any provision of this Agreement will not be construed as a waiver of such party’s rights to insist on performance of such provision or any other provision at some other time.
            </p>
            <p>
              I CONFIRM THAT I HAVE READ AND UNDERSTOOD THESE TERMS AND CONSDITIONS AND AGREE TO THEM AS A CONDITION OF ACCESS AND USE OF THE WEB SITE.
            </p>
          </div>
        </van-collapse-item>
      </van-collapse>

    </van-cell-group>
  </div>
</template>

<script>
import RouterName from '@/constants/route'
import Language from '@/constants/lang'
import CountryCodeInfo from '@/components/CountryCodePane/countrycode'
import { next, loading } from '@/mixin'
import { validPhone, validOtherPhone } from '@/util/validation'
import { Dialog } from 'vant'
import logo from '@/assets/logo.png'
import { logic } from '../common/mixin/logic'

import {
  Image,
  CellGroup,
  Field,
  Button,
  Collapse,
  CollapseItem,
  Checkbox
} from 'vant'

const InitCountdown = 60
export default {
  components: {
    VanImage: Image,
    VanCellGroup: CellGroup,
    VanField: Field,
    VanButton: Button,
    VanCheckbox: Checkbox,
    VanCollapse: Collapse,
    VanCollapseItem: CollapseItem
  },
  mixins: [next, logic, loading],
  data() {
    return {
      logo,
      verifyCode: '',
      countdown: InitCountdown,
      timer: null,
      loginDisable: true,
      campaignId: this.$route.query.campaignId,
      privacyAgreed: false,
      activeNames: ['0'],
      isborder: false
    }
  },
  computed: {
    cCountryInfo: {
      get() {
        let name = ''
        const country = CountryCodeInfo.find(
          v => v.code === this.userInfo.countryCode
        )
        if (!country) {
          return
        }

        if (this.language === Language.ZH) {
          name = country.name
        }
        if (this.language === Language.EN) {
          name = country.name_en
        }
        return `${name} +${country.code}`
      }
    },
    cPhone: {
      get() {
        return this.userInfo.phone
      },
      set(n) {
        this.updateUserInfo(
          Object.assign({}, this.userInfo, {
            phone: n
          })
        )
      }
    },
    // cVerifyCode: {
    //   get() {
    //     return this.userInfo.verifyCode
    //   },
    //   set(n) {
    //     if (n.length > 6) {
    //       n = n.slice(0, 6)
    //     }
    //     this.updateUserInfo(Object.assign({}, this.userInfo, {
    //       verifyCode: n
    //     }))
    //   }
    // },
    cVerifyButtonText() {
      if (this.countdown === InitCountdown) {
        return '获取验证码'
      }
      return `${this.countdown}s后重试`
    },
    cVerifyDisabled() {
      return this.countdown !== InitCountdown
    },
    cParsedCountryCode() {
      return this.cCountryInfo.split('+')[1]
    }
  },
  methods: {
    // check every 200 millisecond
    handleCheck() {
      if (
        this.cCountryInfo &&
        this.cPhone &&
        this.verifyCode &&
        this.privacyAgreed
      ) {
        this.loginDisable = false
        return
      }
      this.loginDisable = true
    },
    // field rule
    rulePhone() {
      if (!this.cPhone) {
        return '请输入手机号码'
      }
      // only check china
      if (this.cCountryInfo.includes('86') && !validPhone(this.cPhone)) {
        return '手机号码格式不合法'
      }
      if (!this.cCountryInfo.includes('86') && !validOtherPhone(this.cPhone)) {
        return '手机号码格式不合法'
      }
    },
    ruleVerifyCode() {
      if (this.verifyCode.length !== 6) {
        return '验证码格式不合法'
      }
    },

    handleSelectCountryCode() {
      const query = this.$route.query

      this.$router.replace({
        name: RouterName.countryPane,
        query: { 'form': this.$route.path, 'params': query }
      })
    },
    handleVerify() {
      const phone = this.rulePhone()
      if (phone) {
        return Dialog.alert({
          message: phone
        })
      }
      if (this.countdown !== InitCountdown) {
        return
      }
      this.getVerifyCode({
        contryCode: this.cParsedCountryCode,
        phoneNo: this.cPhone
      })
      this.countdown -= 1
      this.timer = setInterval(() => {
        if (this.countdown === 0) {
          this.countdown = InitCountdown
          return clearInterval(this.timer)
        }
        this.countdown -= 1
      }, 1000)
    },
    handleLogin() {
      const phoneRule = this.rulePhone()
      const verifyCodeRule = this.ruleVerifyCode()
      if (phoneRule || verifyCodeRule) {
        return Dialog.alert({
          message: phoneRule || verifyCodeRule
        })
      }
      // this.showLoading()
      this.login({
        contryCode: this.cParsedCountryCode,
        phoneNo: this.cPhone,
        verificationCode: this.verifyCode
      })
    }
  }
}
</script>

<style lang="scss">
.pwc-app-login {
  .pwc-privacy {
    .van-checkbox__icon {
      font-size: 14px;
    }
  }
  .van-image {
    display: block;
  }
  .van-button--info {
    background-color: #d04a02;
    border: none;
    > .van-button__text {
      color: #fff;
    }
  }
  .van-button--disabled {
    background-color: rgba(0, 0, 0, 0.12);
  }
}

.pwc-app-login {
  .van-field__label {
      flex: none;
  }
}
</style>

<style lang="scss"  src="./index.scss" scoped />

